<template>
  <div class="container">
    <!-- <img src="../../assets/index/bg.png" alt="" srcset="" class="bg"> -->
        <div class="wrap">
            <img src="../../assets/index/title.png" alt="" srcset="" class="slogan">
            <div class="slogan-text">
                <p>精准量身 个性定制</p>
                <p>虚拟试衣 百变衣随心</p>
            </div>
            <div class="start-btn" @click="to_link()">
                <img src="../../assets/index/btn_bg.png" alt="" srcset="">
                <p>
                  <span>开始量体</span>
                </p>
            </div>
            <vue-audio :file="audioSrc" autoplay></vue-audio>
        </div>
    </div>
</template>
<script>
export default {
    name: 'myHome',
  data() {
    return {
      audioSrc:'https://c.weimobwmc.com/ol-6NoGC/d8f5d4f8f5c444e48d37d44f6255905e.mp3'
    }
  },
  methods: {
    to_link(){
      this.$router.push('userInfo');
    }
  },
  // 例如这个函数就会在组件挂载完成后被调用
  mounted() {
  }
}
</script>
<style src="./index.less" scoped lang="less"></style>